import { render, staticRenderFns } from "./FilterChips.vue?vue&type=template&id=75221134&"
import script from "./FilterChips.vue?vue&type=script&lang=js&"
export * from "./FilterChips.vue?vue&type=script&lang=js&"
import style0 from "./FilterChips.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
